<template>
  <div>
    <a href="#/" class="btn btn-success" @click="showModal()">Request Review</a>

    <b-modal id="bv-modal-example" hide-footer>
      <template #modal-title>Request Review</template>

      <div class="row text-white">
        <div class="col">
          <label class="form-label pt-0 mb-0" for="dealer-name">Finished working on this project?</label>
          <div class="mb-2"><small>We'll let the client know</small></div>
        </div>
      </div>

      <div class="row text-white">
        <div class="col">
            <label class="form-label pt-0 mb-0" for="dealer-name">Note</label> <small>(optional)</small>
            <div class="mb-2"><small>Anything you want to say to the client</small></div>
            <textarea class="form-control shadow-none inputbox" rows="5" placeholder="" v-model="note"></textarea>
        </div>
      </div>

      <div class="row pt-3 pb-2">
        <div class="col">
                  <div>
<button v-if="updating" type="button" class="btn btn-success submit col">
  <i class="fas fa-spinner fa-sm fa-spin mr-2 move-up"></i></button>
        <button v-else type="button" class="btn btn-success submit col" @click="requestReview">Request Review</button>
      </div>
        </div>
      </div>

    </b-modal>
  </div>
</template> 

<script>
export default {
  props: ['project'],

  data() {
    return {
      price: 0,
      note: '',
      updating: false,
      budgets: [],
      projectInfo: {},
    };
  },

  created() {
    
  },

  methods: {

    showModal() {
      this.$bvModal.show("bv-modal-example");
    },

    hideModal() {
      this.$bvModal.hide("bv-modal-example");
    },

    requestReview() {

          this.updating = true;

          axios.post('/projects/request-review', {
            project_id: this.project.id, 
            note: this.note})
        .then((response) => {
          this.hideModal();
          this.updating = false;
          this.projectInfo = response.data;
          this.showToaster('Review request sent');
        });


      },

      showToaster(text) {
      this.$toaster.success(text, { timeout: 2500 });
      },

      sweetfire(text) {

      Swal.fire({
      title: text,
      showConfirmButton: false,
      showDenyButton: false,
      showCancelButton: true,
      focusConfirm: false,
      cancelButtonText: 'Ok',
      customClass: {
              title: "popup-title",
            },
    })

    },
  },
};
</script>

<style scoped>
select.form-select {
  background-color: #ffffff !important;
  border: 2px solid #35363a;
}

.input-group-text.price {
    border-top-left-radius: 5px;
    border-bottom-left-radius: 5px;
    padding-left: 1.0rem;
}

input.form-control.price {
    padding-left: 0rem;
    border-top-left-radius: 0 !important;
    border-bottom-left-radius: 0 !important;
    border-top-right-radius: 5px !important;
    border-bottom-right-radius: 5px !important;
    }

.btn.btn-success.submit, .btn.btn-secondary.submit {
    border-radius: 5px !important;
}
</style>